import { Outlet, Route, Routes } from 'react-router-dom';

import { AuthRequired } from '@/core/providers/auth/auth-required';
import { HybridLayout } from '@/layouts/hybrid-layout';
import { AnalyticsPage } from '@/pages/analytics/analytics-page';
import { AmazonPage } from '@/pages/amazon/amazon-page';
import { DispatchPlaceDetailPage } from '@/pages/dispatch-places/detail/dispatch-place-detail-page';
import { NewDispatchPlacePage } from '@/pages/dispatch-places/new/new-dispatch-place-page';
import { DispatchPlacesPage } from '@/pages/dispatch-places/dispatch-places-page';
import { FinancesPage } from '@/pages/finances/finances-page';
import { HomePage } from '@/pages/home/home-page';
import { MonitoringPage } from '@/pages/monitoring/monitoring-page';
import { NotFoundPage } from '@/pages/not-found/not-found-page';
import { OrdersPage } from '@/pages/orders/orders-page';

/**
 * Main application router.
 * Every secure route is wrapped by `AuthRequired` and rendered inside the
 * application shell.
 *
 * @returns React element with application routes
 */
export function RouterManager() {
  return (
    <Routes>
      <Route
        element={
          <AuthRequired>
            <HybridLayout children={<Outlet />} />
          </AuthRequired>
        }
      >
        <Route path="/" element={<HomePage />} />
        <Route path="/dispatch-places">
          <Route index element={<DispatchPlacesPage />} />
          <Route path="new" element={<NewDispatchPlacePage />} />
          <Route path=":id" element={<DispatchPlaceDetailPage />} />
        </Route>
        <Route path="/orders" element={<OrdersPage />} />
        <Route path="/finances" element={<FinancesPage />} />
        <Route path="/analytics" element={<AnalyticsPage />} />
        <Route path="/monitoring" element={<MonitoringPage />} />
        <Route path="/amazon" element={<AmazonPage />} />
      </Route>

      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
